import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { FiArrowRight } from "react-icons/fi";
import { EXAM_LANDING_PAGES } from "../../data/examLandingData";

const DEFAULT_SLUGS = [
  "ssc-cgl-typing-test",
  "ssc-chsl-typing-test",
  "rrb-typing-test",
  "delhi-police-head-constable-typing-test",
  "bsf-head-constable-typing-test",
  "typing-speed-test",
];

const Shell = styled.section`
  margin: ${({ $compact }) => ($compact ? "2rem 0" : "3rem 0")};
  padding: ${({ $compact }) => ($compact ? "1.25rem" : "1.6rem")};
  border-radius: 18px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(139, 92, 246, 0.07) 100%);
  border: 1px solid rgba(255, 255, 255, 0.09);
  backdrop-filter: blur(14px);
`;

const Eyebrow = styled.div`
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: rgba(167, 139, 250, 0.88);
  margin-bottom: 0.6rem;
`;

const Title = styled.h2`
  margin: 0 0 0.55rem;
  color: #fff;
  font-size: clamp(1.15rem, 2vw, 1.65rem);
  line-height: 1.2;
`;

const Subtitle = styled.p`
  margin: 0 0 1.2rem;
  color: rgba(255, 255, 255, 0.68);
  line-height: 1.65;
  font-size: 0.95rem;
  max-width: 780px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 0.85rem;
`;

const Card = styled(Link)`
  display: grid;
  gap: 0.42rem;
  padding: 0.95rem 1rem;
  text-decoration: none;
  border-radius: 14px;
  color: #fff;
  background: rgba(10, 10, 15, 0.38);
  border: 1px solid rgba(255, 255, 255, 0.08);
  transition: transform 0.2s ease, border-color 0.2s ease, background 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    border-color: rgba(0, 255, 136, 0.34);
    background: rgba(14, 14, 22, 0.66);
  }
`;

const CardTitle = styled.div`
  font-size: 0.96rem;
  font-weight: 700;
  line-height: 1.35;
`;

const CardMeta = styled.div`
  font-size: 0.78rem;
  color: rgba(0, 255, 136, 0.82);
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

const CardText = styled.div`
  font-size: 0.84rem;
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.62);
`;

const CardCta = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  color: #c4b5fd;
  font-size: 0.82rem;
  font-weight: 700;
  margin-top: 0.2rem;
`;

export default function ExamTypingGuidesBlock({
  title = "Popular Exam Typing Guides",
  subtitle = "Explore exact-match guides for SSC, CHSL, RRB, police, and other typing skill tests.",
  slugs = DEFAULT_SLUGS,
  currentSlug,
  compact = false,
}) {
  const items = slugs
    .filter((slug) => slug && slug !== currentSlug)
    .map((slug) => EXAM_LANDING_PAGES[slug])
    .filter(Boolean);

  if (!items.length) return null;

  return (
    <Shell $compact={compact}>
      <Eyebrow>Exam SEO Guides</Eyebrow>
      <Title>{title}</Title>
      <Subtitle>{subtitle}</Subtitle>
      <Grid>
        {items.map((item) => (
          <Card key={item.slug} to={`/${item.slug}`}>
            <CardMeta>{item.exam}</CardMeta>
            <CardTitle>{item.h1}</CardTitle>
            <CardText>{item.metaDescription}</CardText>
            <CardCta>
              Open guide <FiArrowRight />
            </CardCta>
          </Card>
        ))}
      </Grid>
    </Shell>
  );
}
